// // WebSocketService.js

// export default socket;
import { reactive } from "vue";
import { io } from "socket.io-client";
import store from "@/stores/data.js";
export const state = reactive({
  connected: false,
  fooEvents: [],
  barEvents: [],
  domainUrl:
    process.env.NODE_ENV === "production"
      ? "product"
      : process.env.NODE_ENV === "test"
      ? "test"
      : "local",
});

// "undefined" means the URL will be computed from the `window.location` object

export const socket = io("wss://" + state.domainUrl + ".meloha.com", {
  auth: { token: `${localStorage.getItem("tokenIdV2")}` },
  extraHeaders: {
    fcmToken: localStorage.getItem("tokenDevice"),
    "device-info": window.navigation.currentEntry,
    userId: localStorage.getItem("idUser"),
    "ip-info": null,
  },
  secure: true,
  transports: ["websocket"],
  forceBase64: true,
});

socket.on("connect", () => {
  state.connected = true;
  console.log("connect success:", socket);
});

socket.on("disconnect", (event) => {
  state.connected = false;
  console.log("Disconnect:", event);
});

socket.on("foo", (...args) => {
  state.fooEvents.push(args);
});

socket.on("bar", (...args) => {
  state.barEvents.push(args);
});

// socket.on("connect_error", (err) => {
//   console.log("------------ connect_error:", err);
// });

socket.on("new-message", async (data) => {
  // await store.commit("setNotificationSocket", data);

  const recipientUserId = data.senderId;

  if (recipientUserId !== localStorage.getItem("idUser")) {
    console.log("Vaào");
    displayNotification(data.message);
  }

  await store.commit("setAddMessage", data);
  console.log("Data new message:", data);
});

socket.on("message-update-status", async (data) => {
  console.log("Data update message:", data);
});

function displayNotification(data) {
  console.log("data", data);
  // Kiểm tra xem trình duyệt có hỗ trợ thông báo không
  if (!("Notification" in window)) {
    console.error("Trình duyệt của bạn không hỗ trợ thông báo.");
    return;
  }

  // Hiển thị thông báo
  const notification = new Notification("Meloha", {
    body: data.text,
    icon: "https://firebasestorage.googleapis.com/v0/b/heartlink-dating-project.appspot.com/o/dating%2FLogo_meloha.png?alt=media&token=57371433-8a26-4f8b-8149-8b358166a205",
  });

  // Xử lý sự kiện khi người dùng nhấp vào thông báo
  notification.onclick = function () {
    // Xử lý sự kiện khi người dùng nhấp vào thông báo, ví dụ: điều hướng đến một trang cụ thể
    // window.location.href = "/path-to-page";
  };
}
